<ion-header>
  <app-page-header popoverCssClass='pages' [color]=pageColor></app-page-header>
  <app-resources-header [hidden]='!isResourcePage' [title]='"Resources"' [showSearch]='false'></app-resources-header>
</ion-header>
<ion-content appScrollBounce>
  <div class='bottom'>
    <div [ngClass]="['contents', resourcesCssService.responsiveClass(), pageWidth]">
      <app-spinner-overlay [spinning]='!viewDisplayed'></app-spinner-overlay>
      <app-pages-navigation [hidden]='!viewDisplayed' [pages]=pages></app-pages-navigation>
      <main>
          <h1>{{ page.title }}</h1>
          <div [innerHTML]="pageContent"></div>
      </main>
    </div>
  </div>
</ion-content>